import { Injectable } from '@angular/core';

import { WebSocketService } from './web-socket.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  constructor(private readonly _webSocketService: WebSocketService) {}

  public async connect(): Promise<void> {
    return this._webSocketService.connect();
  }

  public disconnect(): void {
    this._webSocketService.disconnect();
  }

  public subscribeImportFileNotification(fileId: string, consume: (notification: any) => void): void {
    const subscription = this._webSocketService.watch(`/topic/notification/files/${fileId}`).subscribe((response: any) => {
      const notification = JSON.parse(response.body);
      consume(notification);
    });
    this._webSocketService.subscribe('watchImportFileNotification', subscription);
  }

  public unsubscribeImportFileNotification(): void {
    this._webSocketService.unsubscribe('watchImportFileNotification');
  }

  public subscribeExportFileNotification(fileId: string, consume: (notification: any) => void): void {
    const subscription = this._webSocketService.watch(`/topic/notification/files/${fileId}`).subscribe((response: any) => {
      const notification = JSON.parse(response.body);
      consume(notification);
    });
    this._webSocketService.subscribe('watchExportFileNotification', subscription);
  }

  public unsubscribeExportFileNotification(): void {
    this._webSocketService.unsubscribe('watchExportFileNotification');
  }
}
